module.exports = __webpack_public_path__ + "static/img/移动应用定制.d96f3b25.png";